import * as i0 from '@angular/core';
import { inject, TemplateRef, Directive, ChangeDetectorRef, PLATFORM_ID, Renderer2, signal, input, booleanAttribute, computed, ElementRef, Component, ContentChildren, ViewChildren, ViewChild, HostListener, ViewEncapsulation } from '@angular/core';
import * as i1 from '@angular/common';
import { isPlatformServer, DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { takeUntil, merge, fromEvent, filter, tap, map, withLatestFrom, concatMap, startWith, Subject, distinctUntilChanged, pairwise, skip, firstValueFrom, take } from 'rxjs';
const _c0 = ["slider"];
const _c1 = ["itemWrapper"];
const _c2 = ["*"];
const _c3 = a0 => ({
  "carousel__items--center": a0
});
const _c4 = a0 => ({
  transition: a0
});
const _c5 = (a0, a1) => ({
  "carousel__item--active": a0,
  "carousel__item--unactive": a1
});
const _c6 = a0 => ({
  "carousel__indicator--inner": a0
});
const _c7 = a0 => ({
  "carousel__indicator-button--active": a0
});
function NgxPxCarouselAwesomePlusComponent_For_5_ng_template_3_Template(rf, ctx) {}
function NgxPxCarouselAwesomePlusComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5, 1);
    i0.ɵɵprojection(2);
    i0.ɵɵtemplate(3, NgxPxCarouselAwesomePlusComponent_For_5_ng_template_3_Template, 0, 0, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5, item_r1.itemIndex + 1 === ctx_r1.indicatorIndex(), item_r1.itemIndex + 1 !== ctx_r1.indicatorIndex()));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", item_r1.content.template);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, "<");
    i0.ɵɵelementEnd();
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, ">");
    i0.ɵɵelementEnd();
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "button", 8);
    i0.ɵɵlistener("click", function NgxPxCarouselAwesomePlusComponent_Conditional_6_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.indexDown());
    });
    i0.ɵɵtemplate(2, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_2_Template, 1, 1, "ng-container")(3, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_3_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 10);
    i0.ɵɵlistener("click", function NgxPxCarouselAwesomePlusComponent_Conditional_6_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.indexUp());
    });
    i0.ɵɵtemplate(5, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_5_Template, 1, 1, "ng-container")(6, NgxPxCarouselAwesomePlusComponent_Conditional_6_Conditional_6_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_2_0 = ctx_r1.arrowPrevTemplate()) ? 2 : 3, tmp_2_0);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional((tmp_3_0 = ctx_r1.arrowNextTemplate()) ? 5 : 6, tmp_3_0);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_For_2_Template_button_click_0_listener($event) {
      const i_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.goToIndicatorIndex(i_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.$implicit;
    const indicatorIndex_r6 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, i_r5 === indicatorIndex_r6 || indicatorIndex_r6 > ctx_r1.indicators.length && i_r5 === ctx_r1.indicators.length));
    i0.ɵɵattribute("aria-label", "Slide " + i_r5);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Conditional_3_Conditional_0_Template, 1, 0, "div", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx.length > ctx_r1.indicators().length ? 0 : -1);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵrepeaterCreate(1, NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_For_2_Template, 1, 4, "button", 13, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(3, NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c6, ctx_r1.innerIndicator()));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.indicators());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_6_0 = ctx_r1.carouselInnerItems()) ? 3 : -1, tmp_6_0);
  }
}
function NgxPxCarouselAwesomePlusComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusComponent_Conditional_7_Conditional_0_Template, 4, 4, "div", 12);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_2_0 = ctx_r1.indicatorIndex()) ? 0 : -1, tmp_2_0);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, "<");
    i0.ɵɵelementEnd();
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, ">");
    i0.ɵɵelementEnd();
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 5);
    i0.ɵɵtemplate(2, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_2_Template, 1, 1, "ng-container")(3, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_3_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 7);
    i0.ɵɵtemplate(5, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_5_Template, 1, 1, "ng-container")(6, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Conditional_6_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_1_0 = ctx_r0.arrowPrevTemplate()) ? 2 : 3, tmp_1_0);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional((tmp_2_0 = ctx_r0.arrowNextTemplate()) ? 5 : 6, tmp_2_0);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const i_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, i_r2 === 0));
    i0.ɵɵattribute("aria-label", "Slide " + i_r2);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
}
function NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵrepeaterCreate(1, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_For_2_Template, 1, 4, "div", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(3, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_Conditional_3_Template, 1, 0, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c6, ctx_r0.innerIndicator()));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.indicatorArray());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.range() > ctx_r0.indicatorArray().length ? 3 : -1);
  }
}
let NgxPxCarouselAwesomePlusItemDirective = /*#__PURE__*/(() => {
  class NgxPxCarouselAwesomePlusItemDirective {
    constructor() {
      this.template = inject(TemplateRef);
    }
    static {
      this.ɵfac = function NgxPxCarouselAwesomePlusItemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxPxCarouselAwesomePlusItemDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxPxCarouselAwesomePlusItemDirective,
        selectors: [["", "ngxPxCarouselItem", ""]],
        standalone: true
      });
    }
  }
  return NgxPxCarouselAwesomePlusItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxPxCarouselAwesomePlusComponent = /*#__PURE__*/(() => {
  class NgxPxCarouselAwesomePlusComponent {
    set childs(items) {
      this.carouselInnerItems.set(items.toArray());
      this.reset();
      if (items.length === 0) return;
      const tmpItems = items.toArray().map((item, i) => {
        return {
          content: item,
          itemIndex: i
        };
      });
      this.clonePool.set([...tmpItems]);
      const correctCenter = this.forceCenter() && this.clonePool().length % 2 === 0;
      this.items.set(this.sliderType() === 'carousel' ? this.setTypeCarouselClones(correctCenter, tmpItems) : tmpItems);
      this.setIndicators();
      this.baseItemLength = (this.items().length - (correctCenter ? 1 : 0)) * (this.sliderType() === 'carousel' ? 1 / this.clonesToAppend() : 1);
      this.cdr.detectChanges();
    }
    setTypeCarouselClones(correctCenter, tmpItems) {
      const tmp = [];
      for (let i = 0; i < this.clonesToAppend(); i++) {
        tmp.push(...tmpItems);
      }
      if (correctCenter) {
        const nextCone = this.getNextCone('forward');
        if (nextCone) {
          tmp.push(nextCone);
        }
      }
      return tmp;
    }
    setIndicators() {
      this.indicators.set([]);
      let maxRange = undefined;
      const maxIndicator = this.maxIndicator();
      if (maxIndicator) {
        if (typeof maxIndicator === 'number') maxRange = maxIndicator;else if (maxIndicator.currentBreakpoint && maxIndicator.indicatorBreakpoints) {
          maxRange = maxIndicator.indicatorBreakpoints[maxIndicator.currentBreakpoint];
        }
      }
      for (let i = 1; i < this.clonePool().length + 1; i++) {
        if (maxRange && i > maxRange) break;
        this.indicators().push(i);
      }
    }
    reset() {
      if (isPlatformServer(this.platform)) return;
      this.clonesDisabled = true;
      this.translateX$.next(0);
      this.items.set([]);
      this.clonePool.set([]);
      this.indicators.set([]);
      this.baseItemLength = 0;
      this.currentIndex.set(0);
      this.indicatorIndex.set(1);
      this.renderer.setStyle(this.slider.nativeElement, 'margin-right', '0px');
      this.renderer.setStyle(this.slider.nativeElement, 'margin-left', '0px');
      this.clonesDisabled = false;
    }
    getIndexByTranslateX(translateX, direction) {
      if (translateX === 0) {
        return 0;
      }
      const width = this.getElementsWidth(this.itemWrappers.first.nativeElement);
      const half = this.getHalf();
      const offsetWidth = width / this.clonesToAppend();
      const offset = direction ? direction === 'left' ? -offsetWidth : offsetWidth : 0;
      const index = -Math.round((translateX + half + offset) / width);
      if (this.sliderType() === 'slider') {
        if (index < 0) {
          return 0;
        }
        if (index >= this.items().length) {
          return this.items().length - 1;
        }
      }
      return index;
    }
    resizeWindow() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.currentIndex.set(this.currentIndex());
      }, 25);
    }
    // eslint-disable-next-line max-lines-per-function, max-statements
    ngOnInit() {
      const sliderNative = this.slider.nativeElement;
      this.translateX$.pipe(takeUntil(this.onDestroy$)).subscribe(x => {
        this.renderer.setStyle(sliderNative, 'transform', `translateX(${x}px)`);
      });
      const start$ = merge(fromEvent(sliderNative, 'mousedown'), fromEvent(sliderNative, 'touchstart')).pipe(filter(startEvent => startEvent instanceof MouseEvent || startEvent.type === 'touchstart'), tap(() => {
        this.renderer.setStyle(sliderNative, 'transition', 'transform 0.0s ease-out');
      }), map(startEvent => {
        if (startEvent.type === 'touchstart') {
          return startEvent.touches[0];
        } else {
          startEvent.preventDefault();
          return startEvent;
        }
      }));
      const move$ = merge(fromEvent(sliderNative, 'mousemove'), fromEvent(sliderNative, 'touchmove')).pipe(map(moveEvent => {
        if (moveEvent.type === 'touchmove') {
          return moveEvent.touches[0];
        } else {
          moveEvent.preventDefault();
          return moveEvent;
        }
      }));
      const stop$ = merge(fromEvent(sliderNative, 'mouseleave'), fromEvent(sliderNative, 'mouseup'), fromEvent(sliderNative, 'touchend')).pipe(withLatestFrom(this.nextIndex$), tap(([, index]) => {
        const snappyDelay = this.delay() / 10 / 2;
        this.renderer.setStyle(sliderNative, 'transition', `transform ${snappyDelay}ms cubic-bezier(0.23, 1, 0.32, 1) 0s`);
        this.currentIndex.set(index);
        this.moveToIndex(index);
        setTimeout(() => {
          this.renderer.setStyle(sliderNative, 'transition', this.baseTransition());
        }, snappyDelay);
      }));
      const click$ = fromEvent(sliderNative, 'click');
      start$.pipe(concatMap(startEvent => {
        const currentTranslateX = this.currentTranslationX();
        const startX = startEvent.pageX;
        return move$.pipe(map(moveEvent => {
          const mouseDelta = moveEvent.pageX - startX;
          const walk = currentTranslateX + mouseDelta;
          this.translateX$.next(walk);
        }), takeUntil(click$), takeUntil(stop$));
      })).subscribe();
      this.translateX$.pipe(filter(translateX => this.sliderType() === 'carousel' || this.isInIndicatorRange(translateX)), takeUntil(this.onDestroy$)).subscribe(translateX => {
        const i = this.getIndexByTranslateX(translateX);
        let length = this.baseItemLength;
        if (this.sliderType() === 'slider') {
          length += 1;
        }
        const mod = (i % length + length) % length + 1;
        this.indicatorIndex.set(Math.floor(mod));
        this.cdr.detectChanges();
      });
      this.active$ = merge(start$.pipe(map(() => true)), stop$.pipe(map(() => false))).pipe(startWith(false), takeUntil(this.onDestroy$));
    }
    constructor() {
      this.cdr = inject(ChangeDetectorRef);
      this.document = inject(DOCUMENT);
      this.platform = inject(PLATFORM_ID);
      this.renderer = inject(Renderer2);
      this.translateX$ = new Subject();
      this.currentIndex = signal(0);
      this.indicatorIndex = signal(1);
      this.disableCloneDelay$ = new Subject();
      this.showControls = input(true, {
        transform: booleanAttribute
      });
      this.showIndicator = input(true, {
        transform: booleanAttribute
      });
      this.centered = input(true, {
        transform: booleanAttribute
      });
      this.forceCenter = input(true, {
        transform: booleanAttribute
      });
      this.sliderType = input('slider');
      this.arrowPrevTemplate = input();
      this.arrowNextTemplate = input();
      this.clonesToAppend = input(3, {
        transform: val => val + 1
      });
      this.maxIndicator = input();
      this.innerIndicator = input(false, {
        transform: booleanAttribute
      });
      this.snapDelay = input(3000);
      this.delay = computed(() => this.snapDelay());
      this.baseTransition = computed(() => `transform 0.${this.delay() / 100}s ease-out`);
      this.items = signal([]);
      this.clonePool = signal([]);
      this.onDestroy$ = new Subject();
      this.indicators = signal([]);
      this.baseItemLength = 0;
      this.clonesDisabled = false;
      this.carouselInnerItems = signal(undefined);
      this.direction$ = this.translateX$.pipe(startWith(0), distinctUntilChanged(), pairwise(), map(vals => vals[1] - vals[0] > 0 ? 'right' : 'left'));
      this.nextIndex$ = this.translateX$.pipe(startWith(0), withLatestFrom(this.direction$), map(([translateX, direction]) => this.getIndexByTranslateX(translateX, direction)));
      toObservable(this.currentIndex).pipe(skip(1), takeUntil(this.onDestroy$)).subscribe(index => {
        if (this.items().length === 0) return;
        this.moveToIndex(index);
      });
    }
    getNextCone(direction) {
      const items = this.items().length === 0 ? this.clonePool() : this.items();
      if (items.length === 0) return null;
      if (direction === 'forward') {
        const lastItemIndex = items[items.length - 1].itemIndex;
        const nextCloneIndex = this.clonePool().findIndex(item => item.itemIndex === lastItemIndex + 1);
        if (nextCloneIndex === -1) {
          const firstCloneIndex = this.clonePool().findIndex(item => item.itemIndex === 0);
          return this.clonePool()[firstCloneIndex];
        }
        return this.clonePool()[nextCloneIndex];
      } else {
        const lastItemIndex = items[0].itemIndex;
        const nextCloneIndex = this.clonePool().findIndex(item => item.itemIndex === lastItemIndex - 1);
        if (nextCloneIndex === -1) {
          const firstCloneIndex = this.clonePool().findIndex(item => item.itemIndex === this.clonePool()[this.clonePool().length - 1].itemIndex);
          return this.clonePool()[firstCloneIndex];
        }
        return this.clonePool()[nextCloneIndex];
      }
    }
    ngAfterViewInit() {
      if (this.sliderType() === 'slider') {
        return;
      }
      this.nextIndex$.pipe(startWith(0), distinctUntilChanged(), withLatestFrom(merge(this.active$, this.disableCloneDelay$)), pairwise(), map(([prev, curr]) => {
        return {
          jumps: curr[0] - prev[0],
          index: curr[0],
          withoutDelay: curr[1]
        };
      })).subscribe(x => {
        if (this.clonesDisabled) return;
        if (x.withoutDelay) {
          this.manageCloneAppend(x.jumps);
        } else {
          setTimeout(() => {
            this.manageCloneAppend(x.jumps);
          }, this.delay() / 10);
        }
      });
      if (isPlatformBrowser(this.platform)) {
        if (!this.centered()) {
          this.renderer.setStyle(this.slider.nativeElement, 'transition', 'none');
          this.jumpToCenter().then(() => {
            this.renderer.setStyle(this.slider.nativeElement, 'transition', this.baseTransition());
          });
        }
      }
    }
    goToIndicatorIndex(goToIndex) {
      const currentIndex = this.currentIndex();
      const currentIndicatorIndex = this.indicatorIndex();
      const move = goToIndex - currentIndicatorIndex;
      const nextIndex = currentIndex + move;
      this.setIndex(nextIndex);
    }
    indexUp() {
      this.setIndex(this.currentIndex() + 1);
    }
    indexDown() {
      this.setIndex(this.currentIndex() - 1);
    }
    currentTranslationX() {
      const sliderNative = this.slider.nativeElement;
      const match = /translateX\((-?\d+\.?\d*)px\)/.exec(sliderNative.style.transform);
      return match ? parseInt(match[1]) : 0;
    }
    ngOnDestroy() {
      this.onDestroy$.next();
    }
    manageCloneAppend(jumps) {
      for (let i = 0; i < Math.abs(jumps); i++) {
        const clone = this.getNextCone(jumps > 0 ? 'forward' : 'backwards');
        if (!clone) break;
        if (jumps > 0) {
          this.items.set([...this.items(), clone]);
        }
        if (jumps < 0) {
          this.items.set([clone, ...this.items()]);
        }
        this.increaseMargin(jumps > 0 ? 1 : -1);
      }
      this.cdr.detectChanges();
    }
    increaseMargin(direction) {
      const ele = this.itemWrappers.first.nativeElement;
      const slider = this.slider.nativeElement;
      const width = this.getElementsWidth(ele);
      const margin = parseInt(direction === -1 ? getComputedStyle(slider).marginLeft : getComputedStyle(slider).marginRight);
      const newMarginLeft = margin - width;
      const style = direction === -1 ? 'margin-left' : 'margin-right';
      this.renderer.setStyle(this.slider.nativeElement, style, `${newMarginLeft}px`);
    }
    getElementsMargin(ele) {
      const marginLeft = parseInt(getComputedStyle(ele).marginLeft);
      const marginRight = parseInt(getComputedStyle(ele).marginRight);
      return marginLeft + marginRight;
    }
    getHalf() {
      // Stays if it is later needed
      return 0;
    }
    moveToIndex(index) {
      const ele = this.itemWrappers.first;
      const width = this.getElementsWidth(ele.nativeElement);
      const half = this.getHalf();
      const walk = index * width + half;
      this.translateX$.next(-walk);
    }
    getElementsWidth(ele) {
      const width = ele.getBoundingClientRect().width;
      const margin = this.getElementsMargin(ele);
      return width + margin;
    }
    getCompleteWidth() {
      const width = this.getElementsWidth(this.itemWrappers.first.nativeElement);
      return width * this.items().length;
    }
    isInIndicatorRange(translateX) {
      if (this.items().length === 0) return true;
      const width = this.getElementsWidth(this.itemWrappers.first.nativeElement);
      return translateX <= 0 && translateX > -(this.getCompleteWidth() - width / 2);
    }
    indexOutOfBounds(index) {
      return index < 0 || index >= this.items().length;
    }
    setIndex(index) {
      if (this.sliderType() === 'slider' && this.indexOutOfBounds(index)) {
        return;
      }
      this.currentIndex.set(index);
    }
    async jumpToCenter() {
      await firstValueFrom(this.itemWrappers.changes.pipe(startWith(this.itemWrappers), filter(wrapper => wrapper.length > 0), take(1)));
      this.disableCloneDelay$.next(true);
      this.currentIndex.set(this.clonePool().length);
    }
    static {
      this.ɵfac = function NgxPxCarouselAwesomePlusComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxPxCarouselAwesomePlusComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxPxCarouselAwesomePlusComponent,
        selectors: [["ngx-px-carousel-awesome-plus"]],
        contentQueries: function NgxPxCarouselAwesomePlusComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NgxPxCarouselAwesomePlusItemDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childs = _t);
          }
        },
        viewQuery: function NgxPxCarouselAwesomePlusComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ElementRef);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemWrappers = _t);
          }
        },
        hostAttrs: ["ngSkipHydration", "true"],
        hostBindings: function NgxPxCarouselAwesomePlusComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function NgxPxCarouselAwesomePlusComponent_resize_HostBindingHandler() {
              return ctx.resizeWindow();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          showControls: [1, "showControls"],
          showIndicator: [1, "showIndicator"],
          centered: [1, "centered"],
          forceCenter: [1, "forceCenter"],
          sliderType: [1, "sliderType"],
          arrowPrevTemplate: [1, "arrowPrevTemplate"],
          arrowNextTemplate: [1, "arrowNextTemplate"],
          clonesToAppend: [1, "clonesToAppend"],
          maxIndicator: [1, "maxIndicator"],
          innerIndicator: [1, "innerIndicator"],
          snapDelay: [1, "snapDelay"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c2,
        decls: 8,
        vars: 8,
        consts: [["slider", ""], ["itemWrapper", ""], [1, "carousel"], [1, "carousel__content"], [1, "carousel__items", 3, "ngClass", "ngStyle"], [1, "carousel__item", 3, "ngClass"], [1, "carousel__controls"], [3, "ngTemplateOutlet"], [1, "carousel__prev-arrow", 3, "click"], [1, "carousel__text-arrow"], [1, "carousel__next-arrow", 3, "click"], [4, "ngTemplateOutlet"], [1, "carousel__indicator", 3, "ngClass"], [1, "carousel__indicator-button", 3, "ngClass"], [1, "carousel__indicator-button", 3, "click", "ngClass"], [1, "carousel__indicator-infinite-button"]],
        template: function NgxPxCarouselAwesomePlusComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4, 0);
            i0.ɵɵrepeaterCreate(4, NgxPxCarouselAwesomePlusComponent_For_5_Template, 4, 5, "div", 5, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NgxPxCarouselAwesomePlusComponent_Conditional_6_Template, 7, 2, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, NgxPxCarouselAwesomePlusComponent_Conditional_7_Template, 1, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, ctx.centered()))("ngStyle", i0.ɵɵpureFunction1(6, _c4, ctx.baseTransition()));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.items());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showControls() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showIndicator() ? 7 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle],
        styles: [".carousel[_ngcontent-%COMP%]{position:relative;overflow:hidden;width:100%}.carousel__content[_ngcontent-%COMP%]{position:relative;height:100%}.carousel__items[_ngcontent-%COMP%]{display:flex;touch-action:pan-y;white-space:nowrap}.carousel__items--center[_ngcontent-%COMP%]{justify-content:center}.carousel__item[_ngcontent-%COMP%]{display:inline-flex;white-space:normal;height:auto}@media (min-width: 1024px){.carousel__item[_ngcontent-%COMP%]{min-width:min-content;max-width:none}}.carousel__item-placeholder[_ngcontent-%COMP%]{width:100%}.carousel__controls[_ngcontent-%COMP%]{display:flex;position:absolute;justify-content:space-between;padding:0 15px;align-items:center;top:50%;transform:translateY(-50%);width:100%}.carousel__text-arrow[_ngcontent-%COMP%]{width:40px;height:40px;background-color:#f5f5f5;border-radius:50%;color:gray;font-size:40px;display:flex;align-items:center;justify-content:center}.carousel__indicator[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;margin-top:20px;gap:8px;position:relative}.carousel__indicator--inner[_ngcontent-%COMP%]{position:absolute;bottom:11px;left:50%;transform:translate(-50%)}.carousel__indicator-button[_ngcontent-%COMP%]{width:14px;height:14px;border:none;border-radius:50%;background-color:#f5f5f5;transition:background-color .15s ease-in-out}.carousel__indicator-button--active[_ngcontent-%COMP%]{background-color:var(--accent, yellow)}.carousel__indicator-infinite-button[_ngcontent-%COMP%]{width:10px;height:10px;border:none;border-radius:50%;background-color:#f5f5f5}"]
      });
    }
  }
  return NgxPxCarouselAwesomePlusComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxPxCarouselAwesomePlusPlaceholderComponent = /*#__PURE__*/(() => {
  class NgxPxCarouselAwesomePlusPlaceholderComponent {
    constructor() {
      this.range = input.required();
      this.showControls = input(true, {
        transform: booleanAttribute
      });
      this.showIndicator = input(true, {
        transform: booleanAttribute
      });
      this.innerIndicator = input(false, {
        transform: booleanAttribute
      });
      this.arrowPrevTemplate = input();
      this.arrowNextTemplate = input();
      this.maxIndicator = input();
      this.indicatorArray = computed(() => this.getArrayFromRange(this.range()));
    }
    getArrayFromRange(range) {
      const maxIndicator = this.maxIndicator();
      if (typeof maxIndicator === 'number' && range > maxIndicator) range = maxIndicator;else if (typeof maxIndicator !== 'number' && maxIndicator?.indicatorBreakpoints && maxIndicator?.currentBreakpoint) {
        const maxRange = maxIndicator.indicatorBreakpoints[maxIndicator.currentBreakpoint] ?? undefined;
        if (maxRange) range = range > maxRange ? maxRange : range;
      }
      return Array.from({
        length: range
      }, (_, index) => index);
    }
    static {
      this.ɵfac = function NgxPxCarouselAwesomePlusPlaceholderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxPxCarouselAwesomePlusPlaceholderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxPxCarouselAwesomePlusPlaceholderComponent,
        selectors: [["ngx-px-carousel-awesome-plus-placeholder"]],
        inputs: {
          range: [1, "range"],
          showControls: [1, "showControls"],
          showIndicator: [1, "showIndicator"],
          innerIndicator: [1, "innerIndicator"],
          arrowPrevTemplate: [1, "arrowPrevTemplate"],
          arrowNextTemplate: [1, "arrowNextTemplate"],
          maxIndicator: [1, "maxIndicator"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c2,
        decls: 6,
        vars: 2,
        consts: [[1, "carousel"], [1, "carousel__content"], [1, "carousel__item-placeholder"], [1, "carousel__controls"], [1, "carousel__indicator", 3, "ngClass"], [1, "carousel__prev-arrow"], [1, "carousel__text-arrow"], [1, "carousel__next-arrow"], [4, "ngTemplateOutlet"], [1, "carousel__indicator-button", 3, "ngClass"], [1, "carousel__indicator-infinite-button"]],
        template: function NgxPxCarouselAwesomePlusPlaceholderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_4_Template, 7, 2, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, NgxPxCarouselAwesomePlusPlaceholderComponent_Conditional_5_Template, 4, 4, "div", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showControls() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showIndicator() ? 5 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet],
        styles: [".carousel{position:relative;overflow:hidden;width:100%}.carousel__content{position:relative;height:100%}.carousel__items{display:flex;touch-action:pan-y;white-space:nowrap}.carousel__items--center{justify-content:center}.carousel__item{display:inline-flex;white-space:normal;height:auto}@media (min-width: 1024px){.carousel__item{min-width:min-content;max-width:none}}.carousel__item-placeholder{width:100%}.carousel__controls{display:flex;position:absolute;justify-content:space-between;padding:0 15px;align-items:center;top:50%;transform:translateY(-50%);width:100%}.carousel__text-arrow{width:40px;height:40px;background-color:#f5f5f5;border-radius:50%;color:gray;font-size:40px;display:flex;align-items:center;justify-content:center}.carousel__indicator{display:flex;justify-content:center;align-items:center;margin-top:20px;gap:8px;position:relative}.carousel__indicator--inner{position:absolute;bottom:11px;left:50%;transform:translate(-50%)}.carousel__indicator-button{width:14px;height:14px;border:none;border-radius:50%;background-color:#f5f5f5;transition:background-color .15s ease-in-out}.carousel__indicator-button--active{background-color:var(--accent, yellow)}.carousel__indicator-infinite-button{width:10px;height:10px;border:none;border-radius:50%;background-color:#f5f5f5}\n"],
        encapsulation: 2
      });
    }
  }
  return NgxPxCarouselAwesomePlusPlaceholderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxPxCarouselAwesomePlusComponent, NgxPxCarouselAwesomePlusItemDirective, NgxPxCarouselAwesomePlusPlaceholderComponent };
